import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private permissionService: PermissionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredPermission = route.data['permission'] as keyof PermissionService;

    // Si no se requiere un permiso específico, permitimos el acceso
    if (!requiredPermission) {
      return true;
    }

    if (
      typeof this.permissionService[requiredPermission] === 'function' &&
      this.permissionService[requiredPermission]()
    ) {
      return true; // El usuario tiene el permiso, puede pasar
    } else {
      // El usuario no tiene el permiso, lo redirigimos
      this.router.navigate(['/permission-denied']);
      return false;
    }
  }
}
